/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClientNoteDto } from '../models/client-note-dto';
import { UserNotesResp } from '../models/user-notes-resp';

@Injectable({
  providedIn: 'root',
})
export class NotesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation userNotes
   */
  static readonly UserNotesPath = '/notes/user/{uuid}';

  /**
   * Get user note
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  userNotes$Response(params: {

    /**
     * user uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<UserNotesResp>> {

    const rb = new RequestBuilder(this.rootUrl, NotesService.UserNotesPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserNotesResp>;
      })
    );
  }

  /**
   * Get user note
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userNotes(params: {

    /**
     * user uuid
     */
    uuid: string;
  }): Observable<UserNotesResp> {

    return this.userNotes$Response(params).pipe(
      map((r: StrictHttpResponse<UserNotesResp>) => r.body as UserNotesResp)
    );
  }

  /**
   * Path part for operation noteDelete
   */
  static readonly NoteDeletePath = '/notes/{uuid}';

  /**
   * Delete a note
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `noteDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  noteDelete$Response(params: {

    /**
     * task uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, NotesService.NoteDeletePath, 'delete');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Delete a note
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `noteDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  noteDelete(params: {

    /**
     * task uuid
     */
    uuid: string;
  }): Observable<{
'success'?: boolean;
}> {

    return this.noteDelete$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * Path part for operation notePut
   */
  static readonly NotePutPath = '/notes';

  /**
   * Note update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notePut$Response(params: {
    body: ClientNoteDto
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, NotesService.NotePutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * Note update
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `notePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notePut(params: {
    body: ClientNoteDto
  }): Observable<{
'success'?: boolean;
}> {

    return this.notePut$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

}
